import moment from "moment";
import { getFullName, getAddress } from "../../util/helpers";
import {
  getLocalPhoneNumber,
  getPdfMargins,
  loadImage,
} from "../../util/helpers";

const setEntityContent = (
  doc,
  hLoc,
  marginTop,
  title,
  content,
  contentMargin,
  width
) => {
  if (content && content.length > 0) {
    doc.setFontSize(13);
    doc.text(title, hLoc - 2, marginTop + 7, {
      align: "right",
    });
    content.forEach((item, i) => {
      if (item.type === "title") {
        doc.setFontSize(12);
        doc.setFont("Rubik", "bold");
      } else {
        doc.setFontSize(9);
        doc.setFont("Rubik", "normal");
      }
      const topMargin = contentMargin
        ? contentMargin + i * 4
        : marginTop + 13 + i * 4;
      if (item.type === "checkbox") {
        doc.setLineDashPattern([1, 0]);
        doc.setDrawColor(217);
        doc.roundedRect(hLoc - 6, topMargin - 4, 3.5, 3.5, 0.5, 0.5);
      } else {
        var splitValue = doc.splitTextToSize(item.value.trim(), width);
        doc.text(splitValue[0], hLoc - 2, topMargin, {
          align: "right",
        });
      }
    });
  }
};

export const setHouseVisitHeader = (intl, doc, record) => {
  const margins = getPdfMargins(doc);
  const organizationName = record.organization.name;
  const phone =
    record.branch && record.branch.phone_number
      ? getLocalPhoneNumber(record.branch.phone_number)
      : null;
  const mobile =
    record.branch && record.branch.mobile_number
      ? getLocalPhoneNumber(record.branch.mobile_number)
      : null;
  const address = getAddress(record.branch.address);
  const from = `${organizationName} - ${record.branch.name}`;
  const title = `${intl.formatMessage({
    id: `app.house_visits_print.title`,
  })} ${moment(record.record.date).format("DD/MM/YYYY")}`;
  const phoneText = phone ? `טלפון: ${phone}` : ``;
  const mobileText = mobile ? `סלולארי: ${mobile}` : ``;
  const addressText = address ? `כתובת: ${address}` : ``;
  doc.setFontSize(9);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font

  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.text(from, hLoc, 20, {
    align: "right",
  });
  doc.setFont("Rubik", "normal");
  doc.text(phoneText, margins, 20, {
    align: "left",
  });
  doc.text(mobileText, margins, 24, {
    align: "left",
  });
  doc.text(addressText, margins, 30, {
    align: "left",
  });
  const logo = record.logo;
  if (logo) {
    doc.addImage(
      logo,
      "png",
      doc.internal.pageSize.getWidth() / 2 - margins,
      12,
      (12 / logo.height) * logo.width,
      12
    );
  }
  doc.setFontSize(14);
  doc.setFont("Rubik", "bold");
  doc.text(title, hLoc, 31, {
    align: "right",
  });
  doc.setFont("Rubik", "normal");
};

export const setHouseVisitContent = (
  doc,
  record,
  intl,
  approvalImg,
  verifyImg
) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik");
  const margins = getPdfMargins(doc);
  setEntitiesBorders(doc, margins);
  setPatientContent(record, doc, margins, intl);

  setVisitorContent(record, doc, margins, intl);
  const generalVPosition = setGeneralContent(record, doc, margins, intl, 72);
  const patientConditionVPosition = setPatientCondition(
    record,
    doc,
    margins,
    intl,
    generalVPosition
  );
  const apartmentConditionVPosition = setApartmentCondition(
    record,
    doc,
    margins,
    intl,
    patientConditionVPosition
  );
  const satisfactionVPosition = setSatistfaction(
    record,
    doc,
    margins,
    intl,
    apartmentConditionVPosition
  );
  setSummary(
    record,
    doc,
    margins,
    intl,
    satisfactionVPosition,
    approvalImg,
    verifyImg
  );
};

const setEntitiesBorders = (doc, margins) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const netoContainersWidth = netoPageWidth - 6;
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0.5, 0.5]);
  const patientCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 10) / 20;
  doc.rect(patientCordinate, 38, (netoContainersWidth * 10) / 20, 30);
  const employeeCordinate = margins;
  doc.rect(employeeCordinate, 38, (netoContainersWidth * 10) / 20, 30);
};

const setPatientContent = (record, doc, margins, intl) => {
  const { patient } = record;
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  const houseNumber = patient?.address?.house_number?.trim();
  const apartmentNumber = patient?.address?.apartment_number?.trim();
  const fullHouseNumber =
    houseNumber && apartmentNumber
      ? `${houseNumber}/${apartmentNumber}`
      : houseNumber
      ? houseNumber
      : "";
  const street = patient?.address?.street
    ? `${patient.address.street.trim()} ${fullHouseNumber}`
    : "-";
  const city =
    patient && patient["address"] && patient["address"]["city"] !== undefined
      ? patient["address"]["city"]
      : "-";
  const fullName = getFullName(patient.surename, patient.first_name);
  const leftContent = [
    {
      type: "title",
      value: fullName,
    },
    {
      title: "detail",
      value:
        patient && patient.local_id_number
          ? patient.local_id_number.toString().split("").reverse().join("")
          : "-",
    },
    {
      title: "detail",
      value: `${city}${street ? `, ${street}` : null}`,
    },
    {
      title: "detail",
      value:
        patient &&
        patient.contact_info &&
        (patient.contact_info.mobile_number ||
          patient.contact_info.phone_number)
          ? getLocalPhoneNumber(
              patient.contact_info.mobile_number
                ? patient.contact_info.mobile_number
                : patient.contact_info.phone_number
            )
              .split("")
              .reverse()
              .join("")
          : "-",
    },
    {
      title: "detail",
      value: patient && patient.live_alone === true ? "כן" : "לא",
    },
  ];

  const rightContent = [
    {
      title: "title",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.patient_name`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.patient.local_id_number`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.patient_address`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.patient.contact_info.phone_number`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.patient.live_alone`,
      }),
    },
  ];
  setEntityContent(
    doc,
    hLoc,
    36,
    intl.formatMessage({
      id: `app.house_visits_print.patient_details`,
    }),
    rightContent,
    0,
    36
  );
  setEntityContent(doc, hLoc - 28, 36, "", leftContent, 0, 50);
};

const setVisitorContent = (record, doc, margins, intl) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const width = ((netoPageWidth - 6) * 10) / 20;
  var hLoc = doc.internal.pageSize.getWidth() - width - 6 - margins;
  let employeeName =
    record.record && record.record.employee
      ? getFullName(
          record.record.employee.surename,
          record.record.employee.first_name
        )
      : "";
  const proffesionalRole =
    record.record && record.record.employee
      ? intl.formatMessage({
          id: `app.dataSelect.professional_role_id.${record.record.employee.professional_role_id}`,
        })
      : "";

  const date = moment(record.record.date).format("DD/MM/YYYY");
  const start = moment(record.record.date).format("HH:mm");
  const end =
    record && record.record.date
      ? moment(record.record.date)
          .add(record.record.duration_minutes, "minutes")
          .format("HH:mm")
      : "";

  const leftContent = [
    {
      type: "title",
      value: employeeName,
    },
    {
      title: "detail",
      value: proffesionalRole,
    },
    {
      title: "detail",
      value: date.split("").reverse().join(""),
    },
    {
      title: "detail",
      value: start.split("").reverse().join(""),
    },
    {
      title: "detail",
      value: end.split("").reverse().join(""),
    },
  ];

  const rightContent = [
    {
      title: "title",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.report_employee_id`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.proffesional_type`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.date`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.date_start`,
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: `app.forms.house_visits_print.duration_minutes`,
      }),
    },
  ];
  setEntityContent(
    doc,
    hLoc,
    36,
    intl.formatMessage({
      id: `app.house_visits_print.visitor_details`,
    }),
    rightContent,
    0,
    36
  );
  setEntityContent(doc, hLoc - 28, 36, "", leftContent, 0, 50);
};

const setGeneralContent = (record, doc, margins, intl, vPosition) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const rightPosition = doc.internal.pageSize.getWidth() - margins - 2;
  const netoContainersWidth = netoPageWidth;
  doc.setFontSize(13);
  doc.text(
    intl.formatMessage({
      id: `app.house_visits_print.general`,
    }),
    rightPosition,
    vPosition + 5,
    {
      align: "right",
    }
  );

  setDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.care_giver_was_presented`,
    }),
    record.record.care_giver_was_presented ? "כן" : "לא",
    rightPosition,
    vPosition + 11
  );

  setDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.time_mathed_planning`,
    }),
    record.record.report.time_mathed_planning ? "כן" : "לא",
    rightPosition - netoPageWidth / 4 + 6,
    vPosition + 11
  );

  setDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits.report.first_visit`,
    }),
    record.record.report.first_visit ? "כן" : "לא",
    rightPosition - (netoPageWidth / 4) * 2 + 2,
    vPosition + 11
  );
  setDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits.report.phone_visit`,
    }),
    record.record.report.phone_visit ? "כן" : "לא",
    rightPosition - (netoPageWidth / 4) * 3 + 2,
    vPosition + 11
  );

  const absenceReasonVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.care_giver_absence_reason`,
    }),
    record.record.report.care_giver_absence_reason || "",
    rightPosition,
    vPosition + 24,
    87
  );

  const otherParticipantsVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.other_participants`,
    }),
    record.record.report.other_participants || "",
    rightPosition - (netoPageWidth / 4) * 2 + 2,
    vPosition + 24,
    87
  );

  const endOfSectionPosition =
    absenceReasonVPosition > otherParticipantsVPosition
      ? absenceReasonVPosition
      : otherParticipantsVPosition;

  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0, 0]);
  const contentCordinate =
    doc.internal.pageSize.getWidth() - margins - netoContainersWidth;
  doc.rect(
    contentCordinate,
    vPosition,
    netoContainersWidth,
    endOfSectionPosition - vPosition - 6
  );
  return endOfSectionPosition - 4;
};

const setPatientCondition = (record, doc, margins, intl, vPosition) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const rightPosition = doc.internal.pageSize.getWidth() - margins - 2;
  const netoContainersWidth = netoPageWidth;
  doc.setFontSize(13);
  doc.text(
    intl.formatMessage({
      id: `app.house_visits_print.patientCondition`,
    }),
    rightPosition,
    vPosition + 5,
    {
      align: "right",
    }
  );
  const appearancesVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.appearances`,
    }),
    record.record.report.appearances || "",
    rightPosition,
    vPosition + 11,
    178
  );

  const nutritionalVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.nutritional_status`,
    }),
    record.record.report.nutritional_status || "",
    rightPosition,
    appearancesVPosition,
    178
  );
  const significantlVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.significant_events`,
    }),
    record.record.report.significant_events || "",
    rightPosition,
    nutritionalVPosition,
    178
  );
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0, 0]);
  const contentCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 20) / 20;
  doc.rect(
    contentCordinate,
    vPosition,
    (netoContainersWidth * 20) / 20,
    significantlVPosition - vPosition - 6
  );
  return significantlVPosition - 4;
};

const setApartmentCondition = (record, doc, margins, intl, vPosition) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const rightPosition = doc.internal.pageSize.getWidth() - margins - 2;
  const netoContainersWidth = netoPageWidth;

  doc.setFontSize(13);
  doc.text(
    intl.formatMessage({
      id: `app.house_visits.apartmentCondition`,
    }),
    rightPosition,
    vPosition + 5,
    {
      align: "right",
    }
  );

  const apartmentConditionVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.apartment_status`,
    }),
    record.record.report.apartment_status || "",
    rightPosition,
    vPosition + 11,
    178
  );

  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0, 0]);
  const contentCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 20) / 20;
  doc.rect(
    contentCordinate,
    vPosition,
    (netoContainersWidth * 20) / 20,
    apartmentConditionVPosition - vPosition - 6
  );
  return apartmentConditionVPosition - 4;
};

const setSatistfaction = (record, doc, margins, intl, vPosition) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const rightPosition = doc.internal.pageSize.getWidth() - margins - 2;
  const netoContainersWidth = netoPageWidth;
  doc.setFontSize(13);
  doc.text(
    intl.formatMessage({
      id: `app.house_visits.satisfaction`,
    }),
    rightPosition,
    vPosition + 5,
    {
      align: "right",
    }
  );

  const satisfactionVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.satisfaction_feedback`,
    }),
    record.record.report.satisfaction_feedback || "",
    rightPosition,
    vPosition + 11,
    87
  );

  const planhoursVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.plan_hours_feedback`,
    }),
    record.record.report.plan_hours_feedback || "",
    rightPosition - (netoPageWidth / 4) * 2 + 2,
    vPosition + 11,
    87
  );

  const secondRowPosition =
    satisfactionVPosition > planhoursVPosition
      ? satisfactionVPosition
      : planhoursVPosition;

  const complainsVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.complains_feedback`,
    }),
    record.record.report.complains_feedback || "",
    rightPosition,
    secondRowPosition,
    87
  );

  const requestsVPosition = setAutoGrowDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.requests_feedback`,
    }),
    record.record.report.requests_feedback || "",
    rightPosition - (netoPageWidth / 4) * 2 + 2,
    secondRowPosition,
    87
  );

  // setDetail(
  //   doc,
  //   intl.formatMessage({
  //     id: `app.forms.house_visits_print.report.complains_feedback`,
  //   }),
  //   record.record.report.complains_feedback || "",
  //   rightPosition,
  //   vPosition + 24
  // );

  // setDetail(
  //   doc,
  //   intl.formatMessage({
  //     id: `app.forms.house_visits_print.report.requests_feedback`,
  //   }),
  //   record.record.report.requests_feedback || "",
  //   rightPosition - (netoPageWidth / 4) * 2 + 10,
  //   vPosition + 24
  // );

  const endOfSectionPosition =
    complainsVPosition > requestsVPosition
      ? complainsVPosition
      : requestsVPosition;

  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0, 0]);
  const contentCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 20) / 20;
  doc.rect(
    contentCordinate,
    vPosition,
    (netoContainersWidth * 20) / 20,
    endOfSectionPosition - vPosition - 6
  );
  return endOfSectionPosition - 4;
};

const setSummary = (
  record,
  doc,
  margins,
  intl,
  vPosition,
  approvalImg,
  verifyImg
) => {
  const rightPosition = doc.internal.pageSize.getWidth() - margins - 2;
  let employeeName =
    record.record && record.record.employee
      ? getFullName(
          record.record.employee.surename,
          record.record.employee.first_name
        )
      : "";

  if (record?.record?.employee?.professional_role_id) {
    const role = intl.formatMessage({
      id: `app.dataSelect.professional_role_id.${record.record.employee.professional_role_id}`,
      defaultMessage: "",
    });
    employeeName = employeeName.concat(", ", role);
  }
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0, 0]);
  doc.setFontSize(13);
  doc.text(
    intl.formatMessage({
      id: `app.house_visits.summary`,
    }),
    rightPosition,
    vPosition + 5,
    {
      align: "right",
    }
  );

  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.text(
    intl.formatMessage({
      id: `app.forms.house_visits_print.report.summary_and_recommendations`,
    }),
    rightPosition,
    vPosition + 11,
    {
      align: "right",
    }
  );
  doc.setFont("Rubik", "bold");
  var splitValue =
    record.record.report.summary_and_recommendations &&
    doc.splitTextToSize(
      record.record.report.summary_and_recommendations.trim(),
      178
    );
  if (splitValue && splitValue.length > 0) {
    splitValue.forEach((i, index) => {
      doc.text(i, rightPosition, vPosition + 16 + index * 5, {
        align: "right",
      });
    });
  }

  doc.setFont("Rubik", "normal");
  const vMargin =
    splitValue && splitValue.length > 0 ? splitValue.length * 5 : 5;

  setDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits.approved`,
    }),
    record.record.approved ? "כן" : "לא",
    rightPosition,
    vPosition + 19 + vMargin
  );
  if (!record.record.report.approved && record.record.reason_not_approved) {
    const reasonNotApprovedData = [
      {
        value: 1,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.hospitalization`,
        }),
      },
      {
        value: 2,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.absence`,
        }),
      },
      {
        value: 3,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.dayCenter`,
        }),
      },
      {
        value: 4,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.householdMemberAbsence`,
        }),
      },
      {
        value: 5,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.refusaToOpen`,
        }),
      },
      {
        value: 6,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.refuseToCooperate`,
        }),
      },
      {
        value: 7,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.InaccessiblePlace`,
        }),
      },
      {
        value: 8,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.otherReason`,
        }),
      },
      {
        value: 9,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.noObligationToVisit`,
        }),
      },
      {
        value: 10,
        name: intl.formatMessage({
          id: `app.dataSelect.houseVisit.completionOfHours`,
        }),
      },
    ];

    const reason = reasonNotApprovedData.filter(
      (i) => i.value === record.record.reason_not_approved
    )[0];
    if (!record.record.approved) {
      setDetail(
        doc,
        intl.formatMessage({
          id: `app.forms.house_visits.reason_not_approved`,
        }),
        reason ? reason.name : "",
        rightPosition - 40,
        vPosition + 19 + vMargin
      );
    }
  }

  setDetail(
    doc,
    intl.formatMessage({
      id: `app.forms.house_visits_print.report_employee_id`,
    }),
    employeeName,
    rightPosition,
    vPosition + 31 + vMargin
  );

  if (approvalImg) {
    const type = approvalImg.src.substring(
      "data:image/".length,
      approvalImg.src.indexOf(";base64")
    );

    doc.addImage(
      approvalImg,
      type,
      rightPosition - 82,
      vPosition + 24 + vMargin,
      (20 / approvalImg.height) * approvalImg.width,
      20
    );
  }

  doc.text(
    intl.formatMessage({
      id: `app.forms.house_visits_print.signature`,
    }),
    rightPosition - 40,
    vPosition + 31 + vMargin,
    {
      align: "right",
    }
  );

  doc.setLineDashPattern([1, 0]);
  doc.line(
    rightPosition - 40,
    vPosition + 37 + vMargin,
    rightPosition - 80,
    vPosition + 37 + vMargin
  );

  if (!record.record.verified) {
    setDetail(
      doc,
      intl.formatMessage({
        id: `app.forms.house_visits_print.report.filled`,
      }),
      record.record.verified ? "כן" : "לא",
      rightPosition - 93,
      vPosition + 31 + vMargin
    );
  } else {
    if (record.record.verified) {
      let verifierName = record?.record?.verified_by?.associated_employee
        ? getFullName(
            record.record.verified_by.associated_employee.surename,
            record.record.verified_by.associated_employee.first_name
          )
        : "";
      if (
        record?.record?.verified_by?.associated_employee?.professional_role_id
      ) {
        const role = intl.formatMessage({
          id: `app.dataSelect.professional_role_id.${record.record.verified_by.associated_employee.professional_role_id}`,
          defaultMessage: "",
        });
        verifierName = verifierName.concat(", ", role);
      }

      setDetail(
        doc,
        intl.formatMessage({
          id: `app.forms.house_visits_print.report.verifiedBy`,
        }),
        verifierName,
        rightPosition - 86,
        vPosition + 31 + vMargin
      );
    }

    if (verifyImg) {
      const verifyImgType = verifyImg.src.substring(
        "data:image/".length,
        verifyImg.src.indexOf(";base64")
      );

      doc.addImage(
        verifyImg,
        verifyImgType,
        rightPosition - 170,
        vPosition + 24 + vMargin,
        (20 / verifyImg.height) * verifyImg.width,
        20
      );
    }

    doc.text(
      intl.formatMessage({
        id: `app.forms.house_visits_print.signature`,
      }),
      rightPosition - 129,
      vPosition + 31 + vMargin,
      {
        align: "right",
      }
    );

    doc.setLineDashPattern([1, 0]);
    doc.line(
      rightPosition - 129,
      vPosition + 37 + vMargin,
      rightPosition - 169,
      vPosition + 37 + vMargin
    );
  }
};
const setDetail = (doc, title, content, hloc, vloc) => {
  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.text(title, hloc, vloc, {
    align: "right",
  });
  doc.setFont("Rubik", "bold");

  doc.text(content, hloc, vloc + 5, {
    align: "right",
  });
  doc.setFont("Rubik", "normal");
};

const setAutoGrowDetail = (doc, title, content, hloc, vloc, width) => {
  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.text(title, hloc, vloc, {
    align: "right",
  });
  doc.setFont("Rubik", "bold");

  var splitValue = content && doc.splitTextToSize(content.trim(), width);

  if (splitValue && splitValue.length > 0) {
    splitValue.forEach((i, index) => {
      doc.text(i, hloc, vloc + 5 + index * 5, {
        align: "right",
      });
    });
  }

  doc.setFont("Rubik", "normal");
  const vMargin =
    splitValue && splitValue.length > 0 ? splitValue.length * 5 + 8 : 13;

  return vloc + vMargin;
};
